const lumiereFire = {
    install(vue, options) {
        vue.prototype.$db = options.db;
        vue.prototype.$auth = options.auth;
    },
};
export default lumiereFire;
